import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _excluded = ["parentId", "parentType"],
    _excluded2 = ["parentId", "parentType"];
var _effectorFileName = "/builds/gmini/front-common/src/classifier-service/ClassifierService/DependenciesService.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.reduce.js";
import { createEffect, forward } from 'effector';
import { adapter } from "../adapters";
import { baseTypesMap } from "./BaseTypesMap";
export function createDependenciesService( // eslint-disable-next-line @typescript-eslint/no-explicit-any
apiCalls) {
  var update = createEffect({
    handler: function handler(_ref) {
      var items = _ref.items;
      return getUpdateNodesMap(items, buildKey, baseTypesMap, adapter);
    }
  }, {
    name: "update",
    sid: "82zh59"
  });
  apiCalls.forEach(function (apiCall) {
    forward({
      ɔ: {
        from: apiCall.doneData,
        to: update
      },
      config: {
        sid: "-6h74se"
      }
    });
  });
  return {
    update: update,
    updatePending$: update.pending
  };
}
export function getUpdateNodesMap(items, buildKeyFunc, baseTypesMap, adapter) {
  var nodesMap = {};
  var childrenMap = new Map();

  for (var i = 0; i < items.length; i++) {
    var _items$i = items[i],
        parentId = _items$i.parentId,
        parentType = _items$i.parentType,
        apiNode = _objectWithoutProperties(_items$i, _excluded);

    var node = adapter(apiNode);

    if (!parentId || !parentType) {
      continue;
    }

    var key = buildKeyFunc({
      id: parentId,
      type: parentType
    });

    if (childrenMap.has(key)) {
      var arr = childrenMap.get(key);
      childrenMap.set(key, arr ? [].concat(_toConsumableArray(arr), [node]) : [node]);
    } else {
      childrenMap.set(key, [node]);
    }
  }

  for (var _i = 0; _i < items.length; _i++) {
    var _items$_i = items[_i],
        _parentId = _items$_i.parentId,
        _parentType = _items$_i.parentType,
        flatNode = _objectWithoutProperties(_items$_i, _excluded2);

    if (flatNode.type === 'BimElementReference') {
      nodesMap = _objectSpread(_objectSpread({}, nodesMap), {}, {
        BimElementNode: nodesMap.BimElementNode ? [].concat(_toConsumableArray(nodesMap.BimElementNode), [adapter(flatNode.element)]) : [adapter(flatNode.element)]
      });
    }

    var _key = buildKeyFunc({
      id: flatNode.id,
      type: flatNode.type
    });

    var _node = adapter(flatNode);

    var nodeWithChildren = _objectSpread(_objectSpread({}, _node), {}, {
      children: childrenMap.get(_key) || []
    });

    var data = nodesMap[baseTypesMap[_node.type]];
    nodesMap = _objectSpread(_objectSpread({}, nodesMap), {}, _defineProperty({}, baseTypesMap[_node.type], data ? [].concat(_toConsumableArray(data), [nodeWithChildren]) : [nodeWithChildren]));
  }

  var nodeMapKeys = Object.keys(nodesMap);
  var result = {
    BimModelNode: {},
    BimCategoryNode: {},
    BimFamilyNode: {},
    BimStandardSizeNode: {},
    BimElementNode: {},
    ReferenceNode: {},
    BaseClassifierNode: {},
    UserClassifierNode: {},
    UserClassifierGroupNode: {},
    AssemblyClassifierNode: {},
    AnonymousClassifierNode: {}
  };
  nodeMapKeys.forEach(function (key) {
    var nodeKey = key;
    var nodesArr = nodesMap[nodeKey];
    result[nodeKey] = nodesArr.reduce(function (obj, node) {
      obj[node.id] = node;
      return obj;
    }, {});
  });
  return result;
}
export function buildKey(params) {
  return "".concat(params.type, ":").concat(params.id);
}